<template>
  <section class="section">
    <div class="row">
      <div class="col-lg-12">

        <div class="pagetitle">
          <h1>Категории</h1>
          <nav>
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
              <li class="breadcrumb-item active">Категории</li>
            </ol>
          </nav>
        </div>

        <div class="card">
          <div class="card-body">

            <h5 class="card-title">Категории</h5>

            <p v-if="loading">Loading...</p>

            <CategoryBlock
                :categories="categories"
                @update="openEdit"
                @delete="openDelete"
                @add="openCreate"
                @drag="onDragEnd"
            />

            <BaseModal
                v-if="isEditOpen"
                title="Изменить категорию"
                @close="closeEdit"
            >
              <CategoryForm
                  :categories="categories"
                  :initial="initial"
                  :error-message="messageError"
                  @submit="onUpdate"
                  @cancel="closeEdit"
              />
            </BaseModal>

            <BaseModal
                v-if="isCreateOpen"
                title="Добавить категорию"
                @close="closeCreate"
            >
              <CategoryForm
                  :initial="initial"
                  :categories="categories"
                  :error-message="messageError"
                  @submit="onAdd"
                  @cancel="closeCreate"
              />
            </BaseModal>

            <DeleteModal
              title="Подтвердите удаление"
              :isOpen="isOpenDelete"
              @accept="onDelete"
              @close="closeDelete"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import {computed, onMounted, reactive, ref} from 'vue';
import { useCategories } from '@/features/categories/composables/useCategories';
import CategoriesTable from "@/features/categories/components/CategoriesTable.vue";
import CategoryForm from "@/features/categories/components/CategoryForm.vue";
import BaseModal from "@/components/ui/components/BaseModal.vue";
import Pagination from "@/components/ui/components/Pagination.vue";
import router from "@/router";
import CategoryBlock from "@/features/categories/components/CategoryBlock.vue";
import DeleteModal from "@/components/ui/components/DeleteModal.vue";

const {
  categories,
  loading,
  isSuccess,
  messageError,
  messageSuccess,
  load,
  addCategory,
  updateCategoryById,
  deleteCategoryById,
  sortCategories,
} = useCategories();

const isCreateOpen = ref(false);
const isEditOpen = ref(false);
const initial = reactive({});

const page = 1;
const size = 1000;

onMounted(async () => {
  await Promise.all([load(page, size)]);
});

function openCreate() {
  isCreateOpen.value = true;
}
function closeCreate() {
  isCreateOpen.value = false;
  for (var field in initial) {
    initial[field] = '';
  }
  messageError.value = "";
}
function openEdit(payload) {
  Object.assign(initial, payload);
  isEditOpen.value = true;
}
function closeEdit() {
  isEditOpen.value = false;
  for (var field in initial) {
    initial[field] = '';
  }
  messageError.value = "";
}

async function onAdd(payload) {
  await addCategory({
    name: payload.name,
  });
  if (isSuccess.value) {
    closeCreate();
    await load(page, size);
  }
}

async function onUpdate(payload) {
  await updateCategoryById(payload.id, {
    name: payload.name,
  });
  if (isSuccess.value) {
    await load(page, size);
    closeEdit();
  }
}

const isOpenDelete = ref(false);
const deleteObj = ref(null);
function openDelete(payload) {
  isOpenDelete.value = true;
  deleteObj.value = payload
}

function closeDelete() {
  isOpenDelete.value = false;
}

async function onDelete() {
  await deleteCategoryById(deleteObj.value.id);
  deleteObj.value = null;
  isOpenDelete.value = false;
  await load(page, size);
}

const onDragEnd = async (categoriesCards) => {
  const sort = categoriesCards.map((acc, index) => ({
    id: acc.id,
    sort: index + 1
  }));

  await sortCategories({categories: sort});
  await load(page, size);
}
</script>

<style scoped>
.red-text {
  color: red;
}
.green-text {
  color: green;
}
</style>
